// src/api/auth.js
import { supabase } from '../supabaseClient';

export const authService = {
  /**
   * Request a magic-link (OTP) to be sent to the user’s email.
   */
  signInWithOtp: async (email) => {
    const { data, error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: `${window.location.origin}/login`, // Or your desired callback page
        shouldCreateUser: true, // auto-signup if email is new
      },
    });
    if (error) {
      console.error('Magic link OTP error:', error.message);
      return { success: false, error: error.message };
    }
    return { success: true, data };
  },

  /**
   * Sign in a user with their email and password.
   */
  signInWithEmailPassword: async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) {
      console.error('Email/Password Sign In error:', error.message);
      return { success: false, error: error.message, data: null };
    }
    return { success: true, data };
  },

  /**
   * Sign up a new user with email and password.
   * Supabase handles email confirmation if enabled in your Supabase project settings.
   */
  signUpWithEmailPassword: async (email, password) => {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        // You can add emailRedirectTo here if you want to redirect after email confirmation
        // emailRedirectTo: `${window.location.origin}/dashboard`,
      },
    });
    if (error) {
      console.error('Sign Up error:', error.message);
      return { success: false, error: error.message, data: null };
    }
    // data.user will be null if email confirmation is required,
    // otherwise it will contain the user and session.
    return { success: true, data };
  },

  logout: async () => {
    const { error } = await supabase.auth.signOut();
    if (error) console.error('Logout error:', error.message);
    return { success: !error, error };
  },

  isAuthenticated: async () => {
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();
    if (error) {
      console.error('Session fetch error:', error.message);
      return false;
    }
    return !!session;
  },
};